import Body from "./Body";

function App() {
  return (
    <div>
      <Body />
    </div>
  );
}
export default App;
